import Image from 'next/image';
import styled, { css } from 'styled-components';

import { Video } from '@swordhealth/ui-corporate';

export const CustomImage = styled(Image)`
  max-width: 560px;
  max-height: 560px;
  ${(props) =>
    props.$objectFit === 'contain' &&
    css`
      object-fit: contain;
    `};

  ${(props) =>
    props.$objectFit === 'cover' &&
    css`
      object-fit: cover;
    `};
`;

export const CustomVideo = styled(Video)`
  border-radius: 16px;
`;

export const ButtonWrapper = styled.div`
  > a {
    //background-color: ${(props) => props.theme.colors.primary.default};
    background-color: var(--ui-button-active-background-primary);
    color: white;
    text-decoration: none;
    font-weight: var(--ui-font-weight-semibold);
    transition: all 0.3s ease;
    &:hover {
      background-color: var(--ui-button-hover-background-primary);
      color: white;
    }
  }
`;

export const Wrapper = styled.div`
  > section {
    padding: 0 !important;
    background-color: transparent;
    > div {
      background-color: transparent;
      > div {
        background-color: transparent;
      }
    }
  }
`;
